import React from "react";
import style from "./BudgetHeader.module.css";

function BudgetHeader(props) {
  return (
    <div className={style.budgetHeader}>
      {props.title ? <h1>{props.title}</h1> : <h3>{props.title}</h3>}
      {props.subtitle && <p>{props.subtitle}</p>}
      <div className={style.yellowBar}></div>
    </div>
  );
}

export default BudgetHeader;
